import type { Component, JSX } from 'solid-js'
import { For, Show } from 'solid-js'

export interface LegendItem<K extends string = string> {
  key: K
  label: string
  color: string
}

export interface ChartLegendProps<K extends string = string> {
  items: LegendItem<K>[]
  activeKeys: Record<string, boolean>
  onToggle: (key: string) => void
  class?: string
}

export interface LegendCheckboxProps {
  label: string
  color: string
  checked: boolean
  onToggle: () => void
  class?: string
}

export const LegendCheckbox: Component<LegendCheckboxProps> = (props) => {
  return (
    <button
      type="button"
      onClick={props.onToggle}
      class={`flex items-center gap-2 transition-opacity ${props.class || ''}`}
      classList={{
        'opacity-100': props.checked,
        'opacity-50': !props.checked
      }}
    >
      <span
        class="flex h-4 w-4 items-center justify-center rounded"
        style={{ 'background-color': props.checked ? props.color : undefined }}
        classList={{
          'border-2 border-gray-300 bg-white': !props.checked
        }}
      >
        <Show when={props.checked}>
          <CheckIcon />
        </Show>
      </span>
      <span class="text-sm text-gray-600">{props.label}</span>
    </button>
  )
}

function ChartLegend<K extends string = string>(props: ChartLegendProps<K>) {
  return (
    <div class={`flex flex-wrap items-center justify-center gap-4 sm:gap-6 ${props.class || ''}`}>
      <For each={props.items}>
        {(item) => (
          <LegendCheckbox
            label={item.label}
            color={item.color}
            checked={props.activeKeys[item.key] ?? false}
            onToggle={() => props.onToggle(item.key)}
          />
        )}
      </For>
    </div>
  )
}

export default ChartLegend

const CheckIcon = (): JSX.Element => (
  <svg class="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
  </svg>
)
